module.exports = __webpack_public_path__ + "static/assets/52797b48d511ecdd8e938684cee7638e.png";